var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconWppMini(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_721_27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.384922 8.89222C0.3845 10.4046 0.78275 11.8813 1.54002 13.1828L0.3125 17.63L4.89913 16.4367C6.16772 17.1219 7.5891 17.481 9.0335 17.4811H9.0373C13.8055 17.4811 17.687 13.6311 17.689 8.89899C17.69 6.60594 16.7908 4.44971 15.1572 2.82748C13.5238 1.20538 11.3515 0.311593 9.03695 0.310547C4.26814 0.310547 0.386961 4.16031 0.384992 8.89222",
    fill: "url(#paint0_linear_721_27)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0752344 8.88949C0.0747422 10.4563 0.487266 11.9858 1.27153 13.334L0 17.9405L4.75109 16.7044C6.06016 17.4126 7.53405 17.786 9.03382 17.7866H9.03769C13.977 17.7866 17.9979 13.7981 18 8.8966C18.0008 6.52116 17.0693 4.28742 15.3773 2.60707C13.6851 0.92693 11.4351 0.000976744 9.03769 0C4.09753 0 0.0772031 3.98791 0.0752344 8.88949ZM2.90461 13.1018L2.72721 12.8223C1.98148 11.6458 1.58787 10.2862 1.58843 8.89005C1.59005 4.81598 4.93158 1.5014 9.0405 1.5014C11.0303 1.50223 12.9004 2.27191 14.3069 3.66837C15.7134 5.06498 16.4873 6.92149 16.4868 8.89605C16.485 12.9701 13.1434 16.2851 9.03769 16.2851H9.03473C7.69788 16.2844 6.38677 15.9282 5.24334 15.255L4.97123 15.0949L2.15184 15.8283L2.90461 13.1017V13.1018Z",
    fill: "url(#paint1_linear_721_27)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.79836 5.17328C6.63059 4.8033 6.45404 4.79584 6.2945 4.78935C6.16386 4.78377 6.01452 4.78419 5.86531 4.78419C5.71597 4.78419 5.47332 4.83993 5.26822 5.06214C5.06291 5.28456 4.48438 5.82205 4.48438 6.91523C4.48438 8.00849 5.28685 9.06498 5.39872 9.21337C5.51073 9.36149 6.94791 11.6767 9.22407 12.5673C11.1158 13.3075 11.5007 13.1603 11.9113 13.1231C12.3219 13.0862 13.2362 12.5858 13.4228 12.0669C13.6095 11.5481 13.6095 11.1034 13.5535 11.0105C13.4975 10.9179 13.3482 10.8623 13.1242 10.7513C12.9002 10.6401 11.7993 10.1026 11.594 10.0284C11.3887 9.9543 11.2394 9.91733 11.0901 10.1398C10.9407 10.362 10.5119 10.8623 10.3812 11.0105C10.2506 11.159 10.1199 11.1775 9.89605 11.0664C9.67196 10.9549 8.95077 10.7206 8.09513 9.96365C7.42941 9.37468 6.97998 8.64735 6.84934 8.42486C6.7187 8.20272 6.83534 8.0823 6.94763 7.97158C7.04825 7.87202 7.17165 7.71212 7.28373 7.58242C7.39538 7.45265 7.43265 7.36007 7.50732 7.21188C7.58206 7.06356 7.54466 6.93379 7.48876 6.82265C7.43265 6.71151 6.99748 5.61261 6.79836 5.17328Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_721_27",
    x1: 869.139,
    y1: 1732.25,
    x2: 869.139,
    y2: 0.310547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_721_27",
    x1: 900,
    y1: 1794.05,
    x2: 900,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_721_27"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWppMini);
export default __webpack_public_path__ + "static/media/icon_wpp_mini.67dc336908f37e7d733b726fd1f38054.svg";
export { ForwardRef as ReactComponent };